import { createHttpAction } from '@securitize/ui-components';
import { GET_OPPORTUNITY_WIZARD_NEXT, RESET_OPPORTUNITY_WIZARD_ACTION } from './actionTypes';

export const getOpportunityWizard = (opportunityId, options) => createHttpAction(GET_OPPORTUNITY_WIZARD_NEXT(opportunityId),
  {}, options).action;

export const resetOpportunityWizard = () => (dispatch) => dispatch({ type: RESET_OPPORTUNITY_WIZARD_ACTION }).action;
